var _defs, _clipPath, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M6.8 11c-1.1 0-2.2-.4-3-1.2-1.6-1.6-1.6-4.3 0-6 .8-.8 1.8-1.2 3-1.2s2.2.4 3 1.2 1.2 1.8 1.2 3c0 1.1-.4 2.2-1.2 3-.8.7-1.9 1.2-3 1.2zm8 2.7l-3.4-3.4c1.7-2.2 1.6-5.5-.5-7.5C9.7 1.6 8.2 1 6.7 1s-2.9.6-4 1.7C.5 4.9.5 8.6 2.7 10.8c1.1 1.1 2.6 1.7 4.1 1.7 1.2 0 2.5-.4 3.5-1.2l3.5 3.4c.2.2.3.2.6.2.2 0 .4-.1.6-.2.1-.2.1-.7-.2-1z"
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    overflow: "visible"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "c",
    d: "M-515-62.2H925v1022H-515z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#d)",
    fill: "#787878",
    d: "M-4-4h24v24H-4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search_icon.3fe4afeffceca78d8e5d9afc14f8df01.svg";
export { ForwardRef as ReactComponent };